import * as types from '../constants/offers';

let initialState = {
  total: null,
  page: 1,
  per_page: 4,
  offers: [],
  offer: null,
  isLoading: false,
  offerGoods: [],
  offerLoading: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.SET_PAGE:
      return {
        ...state,
        page: payload,
      };
    case types.SET_LOADER:
      return {
        ...state,
        isLoading: payload,
      };
    case types.FETCH_OFFERS:
      return {
        ...state,
        offers: payload,
      };
    case types.FETCH_OFFER:
      return {
        ...state,
        offer: payload,
      };
    case types.FETCH_OFFER_GOODS:
      return {
        ...state,
        offerGoods: payload,
      };
    case types.FETCH_FILTERS:
      return {
        ...state,
        ...payload,
      };
    case types.SET_OFFER_LOADER:
      return {
        ...state,
        offerLoading: payload,
      };
    default:
      return state;
  }
};
